module.exports = __webpack_public_path__ + "static/media/mailnews_6.c6e65041.ico";